import { useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { useHelmetTitle } from '@hooks';
import { settingsTabs } from '@content';

import { Layout } from '@components/Layouts';
import { Helmet } from '@components/Shared';
import { AppsTabs } from '@components/Ui';

export const AdminSectionLayout = () => {
  const { makeTitle } = useHelmetTitle();

  const { clusterName } = useParams();
  const [title, setTitle] = useState('');

  return (
    <Layout
      backNavigation={Boolean(clusterName)}
      isProjectReffered={false}
      showHeaderFeatures={false}
      clusterContextTracker={false}
      projectContextTracker={false}
      title={makeTitle('Admin Section', title, clusterName)}
    >
      <Helmet
        description="Admin Section"
        title={makeTitle('Admin Section', title, clusterName)}
      />

      <Layout.Content className="flex flex-col">
        <AppsTabs tabs={settingsTabs.adminSection} setTitle={setTitle} />
        <Outlet />
      </Layout.Content>
    </Layout>
  );
};
